var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { forwardIconRef } from "../../lib/icons";
var SearchIcon = forwardIconRef(function (_a, ref) {
    var _b = _a.color, color = _b === void 0 ? "#fff" : _b, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ ref: ref, xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, props),
        React.createElement("path", { fill: "none", d: "M0 0h20v20H0z" }),
        React.createElement("path", { fill: color, d: "M18.1 19a.9.9 0 01-.552-.189l-.085-.075-3.308-3.307A8.012 8.012 0 019.1 17.2a8.1 8.1 0 118.1-8.1 8.011 8.011 0 01-1.771 5.055l3.307 3.308A.9.9 0 0118.1 19zm-9-16.2a6.3 6.3 0 106.3 6.3 6.307 6.307 0 00-6.3-6.3z" })));
});
export default SearchIcon;
